import { PropsWithChildren } from "react";

import { SxProps, Theme } from "@mui/material/styles";
import { ClassNameMap } from "@mui/styles";

import { NonGenericBaseFormFieldProps } from "@/common/types/baseFormField";
import { InputVibe } from "@/common/types/mui";

export type OptionLabelBaseClasses =
  | "container"
  | "contentSection"
  | "contentSectionCentered"
  | "children"
  | "childrenSmall"
  | "labelSection"
  | "label"
  | "labelNeutral"
  | "labelForm"
  | "disabledLabel"
  | "tooltip"
  | "tooltipSmall"
  | "error"
  | "helperText"
  | "fullWidth"
  | "clickable";

const PREFIX = "OptionLabel";

export const zeffyOptionLabelClasses = {
  container: `${PREFIX}-container`,
  contentSection: `${PREFIX}-contentSection`,
  contentSectionCentered: `${PREFIX}-contentSectionCentered`,
  children: `${PREFIX}-children`,
  childrenSmall: `${PREFIX}-childrenSmall`,
  labelSection: `${PREFIX}-labelSection`,
  label: `${PREFIX}-label`,
  labelNeutral: `${PREFIX}-labelNeutral`,
  labelForm: `${PREFIX}-labelForm`,
  tooltip: `${PREFIX}-tooltip`,
  tooltipSmall: `${PREFIX}-tooltipSmall`,
  disabledLabel: `${PREFIX}-disabledLabel`,
  error: `${PREFIX}-error`,
  helperText: `${PREFIX}-helperText`,
  fullWidth: `${PREFIX}-fullWidth`,
  clickable: `${PREFIX}-clickable`,
};

export interface OptionLabelProps
  extends Pick<NonGenericBaseFormFieldProps, "label" | "errorMessage">, PropsWithChildren<unknown> {
  classes?: Partial<ClassNameMap<OptionLabelBaseClasses>>;
  className?: string;
  vibe?: InputVibe;
  disabled?: boolean;
  helperText?: NonGenericBaseFormFieldProps["label"];
  size?: "medium" | "small";
  tooltipText?: string;
  fullWidth?: boolean;
  alignContent?: "default" | "center";
  "data-test"?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  inputId?: string;
  labelSx?: SxProps<Theme>;
}

export type OptionLabelSsrProps = OptionLabelProps & {
  forwardedRef?: React.Ref<HTMLDivElement>;
};
